import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import ChartLabelTab from './ChartLabelTab';
import closeSrc from './btn-x.svg';
import arrowUpSrc from './arrow-up.svg';
import arrowDownSrc from './arrow-down.svg';
import CompetitionModelCodesDropdown from './CompetitionModelCodesDropdown';

export const ModelPipeline = ({
  activeChart,
  ActiveChartComponent,
  activeChartDescription,
  chartOptions,
  chosenCompCode,
  closeChart,
  collapsedChart,
  competitionCompModelCodes,
  displayCompetitionChart,
  isDropdownOpen,
  modelHasTemplates,
  modelId,
  pipelineStyle,
  selectCompCode,
  showCompetitionModelCodeDropdown,
  toggleDropdown,
  updateSelectedChart,
}) =>
  !collapsedChart ? (
    <div className={pipelineStyle}>
      <div className={styles.chartsHeader}>
        <div className={styles.tabs}>
          {chartOptions.map(({ label, chart }) => (
            <ChartLabelTab
              active={chart === activeChart}
              key={chart}
              chart={chart}
              label={label}
              updateSelectedChart={updateSelectedChart}
            />
          ))}
        </div>
        <div className={styles.activeChartDescription}>
          <div className={styles.activeChartControl}>
            {' '}
            {activeChartDescription}{' '}
            {displayCompetitionChart && (
              <button
                onClick={toggleDropdown}
                className={styles.dropdownToggle}
              >
                {chosenCompCode}
                {isDropdownOpen ? (
                  <img
                    className={styles.carrot}
                    src={arrowUpSrc}
                    alt="dropdown open"
                  />
                ) : (
                  <img
                    className={styles.carrot}
                    src={arrowDownSrc}
                    alt="dropdown close"
                  />
                )}
              </button>
            )}
          </div>
          <CompetitionModelCodesDropdown
            competitionCompModelCodes={competitionCompModelCodes}
            dropdownOpen={showCompetitionModelCodeDropdown}
            selectOption={selectCompCode}
            toggleDropdown={toggleDropdown}
          />
          {modelHasTemplates && (
            <img
              src={closeSrc}
              onClick={closeChart}
              alt="close chart"
              className={styles.chartClose}
            />
          )}
        </div>
      </div>
      <div className={styles.chartContainer}>
        <ActiveChartComponent modelId={modelId} />
      </div>
    </div>
  ) : (
    <div className={styles.pipelineHidden} />
  );

export default enhance(ModelPipeline);
